import { IApplicationState } from '../types/redux';
import { ITopGroup } from '../types/top_three';

export const selectPopularSuburbanLists = (state: IApplicationState) => {
  const { top3 } = state.mainpage;

  const saleList = top3?.find(({ id }) => id === 'sale')?.groups?.find(({ id }) => id === 'suburban_sale');
  const rentList = top3?.find(({ id }) => id === 'rent')?.groups?.find(({ id }) => id === 'suburban_rent');

  return [saleList, rentList].filter(Boolean) as ITopGroup[];
};
